import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet, Router, NavigationEnd } from '@angular/router';
import { DesktopHeaderComponent } from '../../components/header/desktop-header.component';
import { BannerComponent } from '../../components/banner/banner.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { MobileHeaderComponent } from '../../components/header/mobile-header.component';
import { MobileBottomNavComponent } from '../../components/navigation/mobile-bottom-nav.component';
import { HeaderStatsComponent } from '../../components/header/header-stats.component';
import { AdPositions } from '../../../core/services/common/ad.service';

@Component({
  selector: 'app-main-layout',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    DesktopHeaderComponent,
    FooterComponent,
    MobileHeaderComponent,
    MobileBottomNavComponent,
    HeaderStatsComponent,
  ],
  template: `
    <div class="flex flex-col min-h-screen">
      <!-- Header only when not simple page -->
      <ng-container *ngIf="!simplePage">
        <app-desktop-header class="hidden md:block"></app-desktop-header>
        <app-mobile-header class="md:hidden"></app-mobile-header>
      </ng-container>

      <!-- Main content; add top padding only when header present -->
      <div class="flex-grow" [ngClass]="{ 'pt-16': !simplePage }">
        <div class="container mx-auto md:px-4 px-0">
          <div class="flex flex-col md:flex-row">
            <!-- Desktop Side Bar -->
            <div class="hidden md:block w-48 flex-shrink-0"></div>

            <!-- Vertical divider - visible only on desktop -->
            <div
              class="hidden md:block w-px bg-gray-200 dark:bg-dark-border"
            ></div>

            <!-- Main content -->
            <div class="flex-grow">
              <!-- Header stats and future banner container -->
              <div
                *ngIf="showFactsStats"
                class="border-b border-gray-200 dark:border-gray-700"
              >
                <app-header-stats></app-header-stats>
              </div>
              <!-- Router outlet that displays either fact-list or fact-detail based on the current route -->
              <router-outlet></router-outlet>
            </div>

            <!-- Vertical divider - visible only on desktop (right) -->
            <div
              class="hidden md:block w-px bg-gray-200 dark:bg-dark-border"
            ></div>

            <!-- Desktop Right Side Bar -->
            <!-- TODO: ads here through <app-ad-placeholder> -->
            <div class="hidden md:block w-48 flex-shrink-0"></div>
          </div>
        </div>
      </div>

      <!-- Footer -->
      <ng-container *ngIf="!simplePage">
        <app-footer></app-footer>
      </ng-container>

      <!-- Mobile Bottom Navigation -->
      <app-mobile-bottom-nav *ngIf="!simplePage"></app-mobile-bottom-nav>
    </div>
  `,
  styles: [],
})
export class MainLayoutComponent implements OnInit {
  // Expose ad positions to the template
  adPositions = AdPositions;
  isHomePage = false;
  simplePage = false;
  showFactsStats = false;

  constructor(private router: Router) {}

  ngOnInit() {
    // Set initial value
    // TODO: Take off /facts from the list of home pages, once we have a proper home page
    this.isHomePage =
      this.router.url === '/' ||
      this.router.url === '' ||
      this.router.url === '/facts';
    this.simplePage = [
      '/privacy-policy',
      '/terms-of-service',
      '/newuser',
    ].includes(this.router.url);
    this.showFactsStats = this.router.url === '/facts';

    // Update on navigation changes using instanceof to avoid minification issues in production
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        // TODO: Take off /facts from the list of home pages, once we have a proper home page
        this.isHomePage =
          this.router.url === '/' ||
          this.router.url === '' ||
          this.router.url === '/facts';
        this.simplePage = [
          '/privacy-policy',
          '/terms-of-service',
          '/newuser',
        ].includes(this.router.url);
        this.showFactsStats = this.router.url === '/facts';
      }
    });
  }
}
